import { render, staticRenderFns } from "./QuestionDailyAdd.vue?vue&type=template&id=0467496f&scoped=true&"
import script from "./QuestionDailyAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionDailyAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDailyAdd.vue?vue&type=style&index=0&id=0467496f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0467496f",
  null
  
)

export default component.exports